import * as S from './styles'
import {observer} from "mobx-react";
import {FormattedMessage} from "react-intl";

export const Content1 = observer(() => {
    return (
        <S.Container>
            <S.Content>
                <S.Title><FormattedMessage id="benefitTitle"/></S.Title>

                <S.Line1>
                    <S.Blocks>
                        <S.Block>
                            <S.BlockPicture src={"benefit_img1.png"}/>
                            <S.BlockContent>
                                <S.BlockTitle><FormattedMessage id="benefitDesc1"/></S.BlockTitle>
                                <S.BlockText>
                                    <FormattedMessage id="benefitText1"/>
                                </S.BlockText>
                            </S.BlockContent>
                        </S.Block>
                        <S.Block>
                            <S.BlockPicture src={"benefit_img2.png"}/>
                            <S.BlockContent>
                                <S.BlockTitle><FormattedMessage id="benefitDesc2"/></S.BlockTitle>
                                <S.BlockText>
                                    <FormattedMessage id="benefitText2"/>
                                </S.BlockText>
                            </S.BlockContent>
                        </S.Block>
                    </S.Blocks>
                </S.Line1>

                <S.Line2>
                    <S.Blocks>
                        <S.Block>
                            <S.BlockPicture src={"benefit_img4.png"}/>
                            <S.BlockContent>
                                <S.BlockTitle><FormattedMessage id="benefitDesc4"/></S.BlockTitle>
                                <S.BlockText>
                                    <FormattedMessage id="benefitText4"/>
                                </S.BlockText>
                            </S.BlockContent>
                        </S.Block>
                        <S.Block>
                            <S.BlockPicture src={"benefit_img3.png"}/>
                            <S.BlockContent>
                                <S.BlockTitle><FormattedMessage id="benefitDesc3"/></S.BlockTitle>
                                <S.BlockText>
                                    <FormattedMessage id="benefitText3"/>
                                </S.BlockText>
                            </S.BlockContent>
                        </S.Block>
                    </S.Blocks>
                </S.Line2>
            </S.Content>

            <S.MobileContent>
                <S.Title><FormattedMessage id="benefitTitle"/></S.Title>

                <S.Line1>
                    <S.Blocks>
                        <S.Block>
                            <S.BlockPicture src={"benefit_img1.png"}/>
                            <S.BlockContent>
                                <S.BlockTitle><FormattedMessage id="benefitDesc1"/></S.BlockTitle>
                                <S.BlockText>
                                    <FormattedMessage id="benefitText1"/>
                                </S.BlockText>
                            </S.BlockContent>
                        </S.Block>
                    </S.Blocks>
                </S.Line1>

                <S.Line2>
                    <S.Blocks>
                        <S.Block>
                            <S.BlockContent>
                                <S.BlockTitle><FormattedMessage id="benefitDesc2"/></S.BlockTitle>
                                <S.BlockText>
                                    <FormattedMessage id="benefitText2"/>
                                </S.BlockText>
                            </S.BlockContent>
                            <S.BlockPicture src={"benefit_img2.png"}/>
                        </S.Block>
                    </S.Blocks>
                </S.Line2>

                <S.Line1>
                    <S.Block>
                        <S.BlockPicture src={"benefit_img4.png"}/>
                        <S.BlockContent>
                            <S.BlockTitle><FormattedMessage id="benefitDesc4"/></S.BlockTitle>
                            <S.BlockText>
                                <FormattedMessage id="benefitText4"/>
                            </S.BlockText>
                        </S.BlockContent>
                    </S.Block>
                </S.Line1>

                <S.Line2>
                    <S.Block>
                        <S.BlockContent>
                            <S.BlockTitle><FormattedMessage id="benefitDesc3"/></S.BlockTitle>
                            <S.BlockText>
                                <FormattedMessage id="benefitText3"/>
                            </S.BlockText>
                        </S.BlockContent>
                        <S.BlockPicture src={"benefit_img3.png"}/>
                    </S.Block>
                </S.Line2>
            </S.MobileContent>
        </S.Container>
    )
})